import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="mt-auto py-6">
      <div className="container mx-auto px-4">
        <div className="text-center text-sm text-muted-foreground">
          <p>
            © {new Date().getFullYear()} Clan. Tous droits réservés.{' '}
            <Link 
              to="/terms-of-service" 
              className="text-foreground hover:underline"
            >
              Conditions d'utilisation
            </Link>
            {' - '}
            <Link 
              to="/privacy-policy" 
              className="text-foreground hover:underline"
            >
              Politique de confidentialité
            </Link>
            {' - '}
            <Link 
              to="/mentions-legales" 
              className="text-foreground hover:underline"
            >
              Mentions légales
            </Link>
            {' - '}
            <Link 
              to="/support" 
              className="text-foreground hover:underline"
            >
              Support
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;